/* ==========================================================================
   XO Boutique — reattivita' della PDP (blocco C)
   Aggiorna indicatore di disponibilita' e modulo spedizione senza reload.

   L'evento giusto e' 'variant:change', NON 'variant:updated'.
   Verificato leggendo assets/global.min.js:
     - variantChange = "variant:change"
     - VariantChangeBase.connectedCallback fa
         this.form?.addEventListener(variantChange, ...)
       quindi l'evento viaggia sul FORM del prodotto con bubbles:false.
       Ascoltarlo su document non funziona.
     - 'variant:updated' esiste ma lo emette solo <hdt-swatch-card>, cioe' lo
       swatch delle CARD di listing, non il variant picker della PDP.
     - detail.variant porta available, inventory_quantity, inventory_management
       e price: e' la stessa fonte che usa il componente Kalles VariantInventory.

   Nessuna stringa viene costruita qui (R3): tutti i messaggi sono gia' nel DOM,
   tradotti da Liquid. Il JS commuta solo [hidden] e il numero in [data-xo-qty].
   ========================================================================== */
(function () {
  'use strict';

  var VARIANT_CHANGE = 'variant:change';
  var CART_UPDATE = 'cart:update';

  function show(root, attr, state) {
    var nodes = root.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < nodes.length; i++) {
      var match = nodes[i].getAttribute(attr) === state;
      if (match) nodes[i].removeAttribute('hidden');
      else nodes[i].setAttribute('hidden', '');
    }
  }

  /* --- Disponibilita' ---------------------------------------------------- */

  function stockState(variant, urgentMax, countMax) {
    if (!variant || variant.available === false) return 'none';
    // inventory_management null/'' = giacenza non tracciata: se e' acquistabile
    // e' disponibile, e non si inventa un numero.
    if (!variant.inventory_management) return 'available';
    var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : 0;
    if (qty <= 0) return 'available';       // policy 'continue': vendibile oltre lo stock
    if (qty <= urgentMax) return 'urgent';
    if (qty <= countMax) return 'count';
    return 'available';
  }

  function paintStock(el, variant) {
    var urgentMax = parseInt(el.getAttribute('data-xo-urgent-max'), 10) || 1;
    var countMax = parseInt(el.getAttribute('data-xo-count-max'), 10) || 3;
    var state = stockState(variant, urgentMax, countMax);

    if (state === 'count') {
      var qty = variant.inventory_quantity;
      var slots = el.querySelectorAll('[data-xo-qty]');
      for (var i = 0; i < slots.length; i++) slots[i].textContent = qty;
    }

    el.setAttribute('data-xo-state', state);
    el.classList.remove('xo-stock--urgent', 'xo-stock--available', 'xo-stock--neutral');
    el.classList.add('xo-stock--' + (state === 'urgent' ? 'urgent' : state === 'available' ? 'available' : 'neutral'));
    show(el, 'data-xo-stock-state', state);
  }

  /* --- Modulo spedizione -------------------------------------------------- */

  function shipState(cartTotal, price, threshold) {
    if (cartTotal >= threshold) return 'unlocked';
    if (cartTotal + price >= threshold) return 'if_added';
    return 'from';
  }

  function paintShipping(el) {
    var threshold = parseInt(el.getAttribute('data-xo-threshold'), 10) || 0;
    var cartTotal = parseInt(el.getAttribute('data-xo-cart-total'), 10) || 0;
    var price = parseInt(el.getAttribute('data-xo-variant-price'), 10) || 0;
    var state = shipState(cartTotal, price, threshold);
    el.setAttribute('data-xo-ship', state);
    show(el, 'data-xo-ship-state', state);
  }

  /* Il payload di cart:update non e' uniforme: in alcuni punti Kalles passa
     resource:{} e mette i dati in cartData. Si legge quello che c'e', e se non
     si trova un total_price numerico si chiede /cart.js, che e' la fonte
     autorevole e tiene conto dei codici sconto. */
  function readCartTotal(evt, cartUrl) {
    var d = (evt && evt.detail) || {};
    var candidates = [d.resource, d.cartData, d.cart, d.data];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (c && typeof c.total_price === 'number') return Promise.resolve(c.total_price);
    }
    return fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { return cart && typeof cart.total_price === 'number' ? cart.total_price : null; })
      .catch(function () { return null; });
  }

  /* --- Aggancio ----------------------------------------------------------- */

  function bind(el, onVariant) {
    var formId = el.getAttribute('data-xo-form');
    var form = formId ? document.forms[formId] : null;
    if (!form) return false;                       // bubbles:false: serve il form vero
    form.addEventListener(VARIANT_CHANGE, function (e) {
      var v = e && e.detail && e.detail.variant;
      if (v) onVariant(v);
    });
    return true;
  }

  function init() {
    var stocks = document.querySelectorAll('[data-xo-stock]');
    for (var i = 0; i < stocks.length; i++) {
      (function (el) {
        bind(el, function (variant) { paintStock(el, variant); });
      })(stocks[i]);
    }

    var ships = document.querySelectorAll('[data-xo-shipping]');
    for (var j = 0; j < ships.length; j++) {
      (function (el) {
        bind(el, function (variant) {
          if (typeof variant.price === 'number') {
            el.setAttribute('data-xo-variant-price', variant.price);
            paintShipping(el);
          }
        });
        var cartUrl = el.getAttribute('data-xo-cart-url') || '/cart.js';
        document.addEventListener(CART_UPDATE, function (e) {
          readCartTotal(e, cartUrl).then(function (total) {
            if (total === null) return;
            el.setAttribute('data-xo-cart-total', total);
            paintShipping(el);
          });
        });
      })(ships[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
